<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 商品中心->商品列表 -->
    <div class="main">
      <!--<div class="title borderShadow1">商品列表</div>-->
      <div class="main">
        <div class="middle shopclass">
          <div class="cates">
            <div class="cate flexStyle3" style="margin-bottom: 0">
              <div class="left">分类</div>
              <div class="right flexStyle2">
                <span
                  @click="chooseGoodsCate1(item)"
                  :class="
                    item.choosed
                      ? 'hands item item-on c-animation3'
                      : 'hands item c-animation3'
                  "
                  v-for="(item, index) of goodsCateList1"
                  :key="index"
                  >{{ item.classifyShowName || "默认分类" + (index + 1) }}</span
                >
              </div>
            </div>

            <div v-if="goodsCateList2.length > 0" class="cate flexStyle3">
              <div class="left left2"></div>
              <div class="right flexStyle2">
                <span
                  @click="chooseGoodsCate2(item)"
                  :class="
                    item.choosed
                      ? 'hands item item-on c-animation3'
                      : 'hands item c-animation3'
                  "
                  v-for="(item, index) of goodsCateList2"
                  :key="index"
                  >{{ item.classifyShowName || "默认分类" + (index + 1) }}</span
                >
              </div>
            </div>

            <div v-if="goodsCateList3.length > 0" class="cate flexStyle3">
              <div class="left left2"></div>
              <div class="right flexStyle2">
                <span
                  @click="chooseGoodsCate3(item)"
                  :class="
                    item.choosed
                      ? 'hands item item-on c-animation3'
                      : 'hands item c-animation3'
                  "
                  v-for="(item, index) of goodsCateList3"
                  :key="index"
                  >{{ item.classifyShowName || "默认分类" + (index + 1) }}</span
                >
              </div>
            </div>

            <div class="cate flexStyle3">
              <div class="left">品牌</div>
              <div class="right flexStyle2">
                <span
                  @click="chooseGoodsBrand(item)"
                  :class="
                    item.choosed
                      ? 'hands item item-on c-animation3'
                      : 'hands item c-animation3'
                  "
                  v-for="(item, index) of goodsBrandList"
                  :key="index"
                  >{{ item.brandName || "品牌" + (index + 1) }}</span
                ><span
                  v-if="isBrand == 1"
                  @click="showBrand(0)"
                  :class="'hands item c-animation3'"
                  >更多...</span
                ><span
                  v-if="isBrand == 2"
                  @click="showBrand(10)"
                  :class="'hands item c-animation3'"
                  >隐藏...</span
                >
              </div>
            </div>
            <div class="cate flexStyle3">
              <div class="left">价格</div>
              <div class="right flexStyle2">
                <span
                  @click="chooseGoodsPriceArea(item)"
                  :class="
                    item.choosed
                      ? 'hands item item-on c-animation3'
                      : 'hands item2 c-animation3'
                  "
                  v-for="(item, index) of goodsPriceArea"
                  :key="index"
                  >{{ item.text || "默认价格" + (index + 1) }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <!--<div
          class="top flexStyle2"
          style="border-bottom: 1px solid #eee;padding-bottom:20px; "
        >
          <el-button
            icon="el-icon-download"
            type="primary"
            size="small"
            style="width:150px;"
            @click="getBefore"
            >导出商品</el-button
          >
        </div>-->
        <div class="center_pic" style="width: 100%; height: 100%">
          <div class="df-adm">
            <img v-if="advertImg != ''" :src="advertImg" />
            <img v-else src="../../../image/ad1.jpg" />
          </div>
          <ul>
            <li v-for="(item, index) of aryList" :key="index">
              <div class="showbox-pic">
                <img v-if="item.pcImg" :src="getImg3(item)" class="img2" />
                <img v-else src="../../../images/image.png" class="img2" />
              </div>

              <div class="showbox-tit">
                <el-link :underline="false" @click="showInfo(index, item)"
                  ><span>{{ item.goodsName || "默认商品名称" }}</span></el-link
                >
              </div>
              <div class="shopbox-m">
                <div style="padding: 3px; height: 22px; clear: both">
                  商品SKU：<b>{{ item.goodsCode || "--" }}</b>
                </div>
                <div style="padding: 3px; height: 22px; clear: both">
                  建议零售价：<span
                    >¥{{ to_f(item.marketPrice || "0.00") }}</span
                  >
                </div>
                <div style="padding: 3px; height: 22px; clear: both">
                  分销价：<span>¥{{ to_f(item.shopPrice || "0.00") }}</span>
                </div>
                <div style="padding: 3px; height: 22px; clear: both">
                  库存数量：<span>{{ getGoodsStock(item) }}</span>
                </div>
                <div style="padding: 5px 0; height: 22px; clear: both">
                  <el-input-number
                    v-model="item.num"
                    :min="1"
                    :max="1000"
                    size="mini"
                    step-strictly
                    style="width: 110px"
                  ></el-input-number>
                  <div
                    style="float: right; margin-right: 5px; margin-top: -10px"
                  >
                    <el-button
                      type="primary"
                      size="small"
                      @click="addCart(index, item)"
                      icon="el-icon-shopping-cart-full"
                      circle
                    ></el-button>
                  </div>
                </div>
              </div>
              <div style="clear: both"></div>
            </li>
          </ul>
        </div>
        <br />
        <div style="display: none; clear: both" class="bottom">
          <div
            class="hands goods flexStyle3 borderShadow"
            v-for="(item, index) of aryList"
            :key="index"
          >
            <div class="left">
              <img v-if="item.pcImg" :src="item.pcImg" class="img" />
              <img v-else src="../../../images/task1.png" class="img" />
            </div>
            <div class="middle">
              <div class="title twoLine">
                {{ item.goodsName || "默认商品名称" }}
              </div>
              <div class="sku oneLine">
                {{ item.goodsCode || "默认商品sku" }}
              </div>
              <div class="price flexStyle2">
                <div class="newMoney money oneLine">
                  市场价:¥{{ item.marketPrice || "0.00" }}
                </div>
              </div>
            </div>
            <div class="num">
              <span
                class="item parse c-animation"
                @click="goodsNumberParse(-1, index)"
                >-</span
              >
              <span class="item num">{{ item.num }}</span>
              <span
                class="item parse c-animation"
                @click="goodsNumberParse(1, index)"
                >+</span
              >
            </div>
            <div class="right">
              <div
                class="hands btns c-animation"
                @click="watchGoodsDetail(item)"
              >
                查看详情
              </div>
              <div class="hands btns c-animation" @click="addShppingCar(item)">
                加入购物车
              </div>
            </div>
          </div>
          <div class="none" v-if="aryList.length <= 0">暂无可选择商品</div>
        </div>
        <div style="clear: both"></div>
        <div style="text-align: center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="display: inline-block"
          >
          </el-pagination>
          <el-button size="mini" style="display: inline-block">GO</el-button>
        </div>
      </div>
    </div>
    <!-- 商品中心->商品列表 -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import {
  getUrl,
  addShppingCarRequest,
  goodsListRequest,
  goodsPriceCateListRequest,
  exportReequest,
  addCartRequest,
  getBrandListRequest,
  getClassifyListRequest,
} from "../../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      totalPages: 1, // 1.1.总页码,
      pageNum: 1, // 1.2.当前页码
      total: 1, // 1.3.总条数
      pageSize: 100, // 1.4.每页条数
      aryList: [], // 1.5.商品列表数据
      token: "", // 1.6.token
      classifyId: null, // 1.7.商品分类id
      priceRange: "", // 1.8.市场价格
      brandId: null,
      goodsCateList: [
        // 1.9.商品分类列表
        { classifyShowName: "全部", choosed: 1, classifyId: "" },
      ],
      goodsCateList1: [],
      goodsCateList2: [],
      goodsCateList3: [],
      goodsCateList4: [],
      isBrand: 1,
      goodsBrandAryList: [
        // 1.9.商品品牌列表
        { brandName: "全部", choosed: 1, brandId: "" },
      ],
      goodsBrandList: [
        // 1.9.商品品牌列表
        { brandName: "全部", choosed: 1, brandId: "" },
      ],
      goodsPriceArea: [
        // 1.10.商品价格区间列表
        { text: "全部", choosed: 1, content: "" },
      ],
      addShoppingCarTimer: null, // 1.11.加入购物车防止连点
      searchText: "",
      searchType: 0,
      advertImg: "",
    };
  },

  components: {},

  methods: {
    getImg3(item) {
      let r = "";
      if (item.pcImg) {
        let ary = item.pcImg.split(",");
        for (let j = 0; j < ary.length; j++) {
          r = ary[j];
          if (r != "") {
            break;
          }
        }
      }
      return r;
    },
    getGoodsStock(o) {
      let r = 0;
      let v = o.goodsStock;
      if (v) {
        if (v.isSupplier == "1") {
          if (v <= 0) {
            r = "0";
          } else {
            r = v;
          }
        } else {
          if (v >= 9999) {
            r = "有货";
          } else if (v <= 0) {
            r = v;
          } else {
            r = v;
          }
        }
      }
      return r;
    },
    // 3.methods
    goodsNumberParse(parse, index) {
      // 3.1.商品数量调整
      if (this.aryList[index].num + parse <= 0) {
        this.$notify({
          title: "提示",
          message: "商品数量不可小于1",
        });
        return;
      }

      this.aryList[index].num += parse;
    },
    addCart(index, row) {
      let data = {
        index: index,
        goodsId: row.goodsId,
        amount: row.num,
      };
      addCartRequest(data).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: "成功加入购物车",
          });
          this.$emit("addSuccess");
        }
      });
    },

    addShppingCar(item) {
      // 3.2.加入购物车
      clearTimeout(this.addShoppingCarTimer);

      this.addShoppingCarTimer = setTimeout(() => {
        let data = {
          goodsId: item.goodsId,
          amount: item.num,
        };

        addShppingCarRequest(data).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: "成功加入购物车",
            });
            this.$emit("addSuccess");
          }
        });
      }, 200);
    },

    watchGoodsDetail(item) {
      // 3.3.查看商品详情
      let obj = encodeURIComponent(JSON.stringify(item));
      this.$router.push("/goodsDetail?obj=" + obj);
    },

    showInfo(index, item) {
      item.index = index;
      // 3.3.查看商品详情
      let obj = encodeURIComponent(JSON.stringify(item));
      this.$router.push("/goodsDetail?obj=" + obj);
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getList();
    },
    isMoney(money) {
      var reg =
        /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
      if (reg.test(money)) {
        return true;
      } else {
        return false;
      }
    },
    getList() {
      // 3.7.获取商品列表信息
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        classifyId: this.classifyId,
        priceRange: this.priceRange,
        brandId: this.brandId,
        goodsName: this.searchText,
      };
      if (this.searchType == 1) {
        data.brandName = this.searchText;
        data.goodsName = null;
      } else if (this.searchType == 2) {
        data.goodsName = null;
        if (this.isMoney(this.searchText)) {
          data.priceRange = this.searchText + "-" + this.searchText;
        }
      }

      goodsListRequest(data).then((res) => {
        if (res) {
          this.total = res.totals || 1;
          this.totalPages = Math.ceil(res.totals / this.pageSize) || 1;
          this.aryList = res.data.map((item) => {
            item.num = 1;
            return item;
          });

          this.goodsName = "";
        }
      });
    },
    getGoodsCateInfo() {
      // 3.8.获取商品分类列表

      // goodsCateListRequest("").then((res) => {
      //   if (res) {
      //     let list = res.data.map((item) => {
      //       item.choosed = 0;
      //       return item;
      //     });

      //     this.goodsCateList = [...this.goodsCateList, ...list];
      //   }
      // });

      getClassifyListRequest({}).then((res) => {
        if (res) {
          let list = res.data.map((item) => {
            item.choosed = 0;
            return item;
          });

          let ary = this.getSonAry(res.data, 0);
          console.log(ary);
          if (ary.length == 1) {
            this.goodsCateList1 = this.getAryCategory(ary[0]);
            if (this.goodsCateList1.length > 0) {
              this.goodsCateList2 = this.getAryCategory(this.goodsCateList1[0]);
              if (this.goodsCateList2.length > 0) {
                this.goodsCateList3 = this.getAryCategory(
                  this.goodsCateList2[0]
                );
                if (this.goodsCateList3.length > 0) {
                  this.goodsCateList4 = this.getAryCategory(
                    this.goodsCateList3[0]
                  );
                }
              }
            }
          }
          this.goodsCateList = [...this.goodsCateList, ...list];
        }
      });
    },

    getSonAry(ary, parentId) {
      let itemArr = [];
      for (let i = 0; i < ary.length; i++) {
        let node = ary[i];
        if (node.parentId === parentId) {
          let newNode = {};
          newNode.classifyId = node.classifyId;
          newNode.classifyShowName = node.classifyShowName;
          newNode.parentId = node.parentId;
          newNode.choosed = 0;
          let ary1 = this.getSonAry(ary, node.classifyId);
          if (ary1.length > 0) {
            newNode.children = ary1;
          }
          itemArr.push(newNode);
        }
      }
      return itemArr;
    },

    getGoodsBrandInfo() {
      // 3.8.获取商品品牌列表
      getBrandListRequest({}).then((res) => {
        if (res) {
          let list = res.data.map((item) => {
            item.choosed = 0;
            return item;
          });
          this.goodsBrandAryList = [...this.goodsBrandAryList, ...list];
          this.showBrand(10);
        }
      });
    },
    showBrand(v) {
      let pp = this.goodsBrandAryList.length;
      if (v > 0) {
        this.isBrand = 1;
        if (pp > v) {
          pp = v;
        } else {
          this.isBrand = 0;
        }
      } else {
        this.isBrand = 2;
      }
      let list = [];
      for (let j = 0; j < pp; j++) {
        list.push(this.goodsBrandAryList[j]);
      }
      this.goodsBrandList = list;
    },

    chooseGoodsCate(item) {
      // 3.9.选择商品分类
      if (!item.choosed) {
        this.goodsCateList.forEach((item) => (item.choosed = 0));
        item.choosed = 1;

        this.classifyId = item.classifyId;
        this.pageNum = 1;
        this.getList();
      }
    },

    getAryCategory(item) {
      if (item.children) {
        let ary1 = [];
        ary1.push({
          classifyShowName: "全部",
          choosed: 1,
          classifyId: item.classifyId,
        });
        let ary = item.children || [];
        ary.forEach((item) => (item.choosed = 0));
        if (ary.length > 0) {
          let ary0 = [];
          for (let p = 0; p < ary.length; p++) {
            let row3 = ary[p];
            if (row3.children) {
              for (let j = 0; j < row3.children.length; j++) {
                ary0.push(row3.children[j]);
              }
            }
          }
          ary1[0].children = ary0;
          return [...ary1, ...ary];
        }
      }
      return [];
    },

    chooseGoodsCate1(item) {
      this.searchText = null;
      this.searchType = null;
      if (localStorage.searchText) {
        localStorage.searchText = null;
        localStorage.searchType = null;
      }
      // 3.9.选择商品分类
      if (!item.choosed) {
        this.goodsCateList1.forEach((item) => (item.choosed = 0));
        item.choosed = 1;
        this.goodsCateList2 = this.getAryCategory(item);
        if (this.goodsCateList2.length > 0) {
          this.goodsCateList3 = this.getAryCategory(this.goodsCateList2[0]);
          if (this.goodsCateList3.length > 0) {
            this.goodsCateList4 = this.getAryCategory(this.goodsCateList3[0]);
          }
        }
        this.classifyId = item.classifyId;
      }
      this.pageNum = 1;
      this.getList();
    },
    chooseGoodsCate2(item) {
      this.searchText = null;
      this.searchType = null;
      if (localStorage.searchText) {
        localStorage.searchText = null;
        localStorage.searchType = null;
      }
      // 3.9.选择商品分类
      if (!item.choosed) {
        this.goodsCateList2.forEach((item) => (item.choosed = 0));
        item.choosed = 1;

        this.goodsCateList3 = this.getAryCategory(item);
        if (this.goodsCateList3.length > 0) {
          this.goodsCateList4 = this.getAryCategory(this.goodsCateList3[0]);
        }
        this.classifyId = item.classifyId;
      }

      this.pageNum = 1;
      this.getList();
    },
    chooseGoodsCate3(item) {
      this.searchText = null;
      this.searchType = null;
      if (localStorage.searchText) {
        localStorage.searchText = null;
        localStorage.searchType = null;
      }
      // 3.9.选择商品分类
      if (!item.choosed) {
        this.goodsCateList3.forEach((item) => (item.choosed = 0));
        item.choosed = 1;
        this.goodsCateList4 = item.children;
        this.classifyId = item.classifyId;
      }

      this.pageNum = 1;
      this.getList();
    },

    getPriceAreaInfo() {
      // 3.10.获取商品商品价格区间
      goodsPriceCateListRequest("").then((res) => {
        if (res) {
          let list = res.data.map((item) => {
            let obj = {};
            obj.choosed = 0;
            obj.content = item;
            obj.text = item;
            return obj;
          });

          this.goodsPriceArea = [...this.goodsPriceArea, ...list];
        }
      });
    },

    chooseGoodsPriceArea(item) {
      this.searchText = null;
      this.searchType = null;
      if (localStorage.searchText) {
        localStorage.searchText = null;
        localStorage.searchType = null;
      }
      // 3.11.选择商品价格区间
      if (!item.choosed) {
        this.goodsPriceArea.forEach((item) => (item.choosed = 0));
        item.choosed = 1;
      }

      this.priceRange = item.content;
      this.pageNum = 1;
      this.getList();
    },

    chooseGoodsBrand(item) {
      this.searchText = null;
      this.searchType = null;
      if (localStorage.searchText) {
        localStorage.searchText = null;
        localStorage.searchType = null;
      }
      // 3.9.选择商品分类
      if (!item.choosed) {
        this.goodsBrandList.forEach((item) => (item.choosed = 0));
        item.choosed = 1;
      }
      this.brandId = item.brandId;
      this.pageNum = 1;
      this.getList();
    },

    getBefore() {
      // 3.12.导出商品列表之前
      let _this = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认导出?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.get();
          }
        },
      });
    },

    get() {
      let qq =
        "?classifyId=" +
        this.classifyId +
        "&priceRange=" +
        this.priceRange +
        "&brandId=" +
        this.brandId +
        "&goodsName=" +
        this.searchText;
      exportReequest("api/goods/export" + qq).then((res) => {
        if (res) {
          var aLink = document.createElement("a");
          aLink.href = getUrl(res.url);
          aLink.download = "商品列表.xls";
          aLink.style.display = "none";
          aLink.target = "_blank";
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
        }
      });
    },
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      if (localStorage.searchText) {
        this.searchText = localStorage.searchText;
        this.searchType = localStorage.searchType;
      }

      if (localStorage.baseInfo) {
        let r = JSON.parse(localStorage.baseInfo);
        if (r) {
          this.advertImg = r.web_good_advert || "";
        }
      }

      this.getGoodsCateInfo(); // 4.2.获取商品分类信息
      this.getGoodsBrandInfo(); //
      this.getPriceAreaInfo(); // 4.3.获取商品商品价格区间
      this.getList(); // 4.1.获取商品列表信息
    }
  },
};
</script>

<style scoped lang="scss">
$ui-width: 1350px;
@function px2vw($px) {
  @return $px / $ui-width * 100vw;
}

$mainColor1: #e65a5a;
$mainColor2: #dd3242;
$mainColor3: #ff0000;

/* 1.all-container-style-start */
.all-container {
  /*border-radius: px2vw(6px);
  overflow: hidden;
  box-sizing: border-box;
  padding: px2vw(2px);*/
  width: 100%;

  > .main {
    /*flex: 1;
    border-radius: px2vw(1px);
    overflow: hidden;
    box-sizing: border-box;
    padding: px2vw(2px);*/

    > div {
      border-radius: px2vw(1px);
      overflow: hidden;
      margin-bottom: px2vw(20px);
      overflow: hidden;
      width: 100%;
      box-sizing: border-box;
      //padding: px2vw(10px) px2vw(20px);
    }

    > .title {
      font-size: 15px;
      color: #f2f2f2;
      font-weight: bold;
      background-color: #ed8027;
    }

    > .main {
      > .top {
        flex-wrap: wrap;
        margin: 20px 0;

        > .item {
          padding: 10px 20px;
          background-color: $mainColor1;
          color: #fff;
          border-radius: px2vw(4px);
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 px2vw(10px) px2vw(10px) 0;
        }
      }

      > .middle {
        margin-bottom: 20px;
        border-top: 0px solid #eee;
        padding: 20px 0 1px;

        > .title {
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 9px;
          font-weight: blod;
        }

        > .cates {
          font-size: 13px;

          > .cate {
            box-sizing: border-box;
            margin-bottom: px2vw(10px);
            align-items: baseline;

            > .left {
              width: 90px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              flex-shrink: 0;
              font-size: 16px;
              border: 1px solid #be1d22;
              color: #707070;
            }
            > .left2 {
              border: none;
            }

            > .right {
              flex: 1;
              flex-wrap: wrap;
              padding-left: 10px;

              > .item {
                padding: 0 14px 6px;
                font-size: 16px;
                color: #737172;
              }

              > .item-on {
                color: $mainColor3;
              }

              > .item2 {
                padding: 0 14px 6px;
                font-size: 16px;
                color: #5e8db7;
              }
            }
            > .jiage {
              > .item {
                color: #5e8db7;
              }
            }
          }
        }
      }
      > .bottom {
        > .goods {
          margin-bottom: 17px;
          box-sizing: border-box;
          padding: 10px;
          border-radius: 5px;
          overflow: hidden;
          font-size: px2vw(12px);

          > .left {
            flex-shrink: 0;
            width: px2vw(100px);
            height: px2vw(100px);
            max-width: 100px;
            max-height: 100px;
            margin-right: px2vw(20px);
            background-color: #fff;
            border-radius: px2vw(4px);
          }

          > .middle {
            flex: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;

            > .title {
              font-size: 15px;
              font-weight: bold;
            }

            > .sku {
              font-size: 13px;
              color: #999;
              margin: 4px 0 10px;
            }

            > .price {
              > .money {
                min-width: 22%;
                max-width: 34%;
                margin-right: 20px;
                font-size: 13px;
                color: $mainColor3;
              }

              > .oldMoney {
                color: #333;
                font-size: 12px;
              }
            }
          }

          > .num {
            flex-shrink: 0;
            margin-left: 40px;
            display: flex;
            font-size: 13px;
            align-items: flex-end;
            padding-bottom: 10px;

            > .item {
              width: px2vw(20px);
              height: px2vw(20px);
              max-width: 20px;
              max-height: 20px;
              border: 1px solid #999;
              margin: 6px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 3px;
            }
          }

          > .right {
            flex-shrink: 0;
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            > .btns {
              width: px2vw(80px);
              height: px2vw(30px);
              max-width: 80px;
              max-height: 30px;
              background-color: $mainColor1;
              color: #fff;
              border-radius: px2vw(4px);
              font-size: 12px;
              display: flex;
              align-items: center;
              justify-content: center;

              &:nth-child(1) {
                margin-bottom: px2vw(15px);
              }
            }
          }
        }

        > .none {
          font-size: 15px;
          color: #999;
        }
      }
    }
  }
}
.center_pic {
  border-top: 3px solid #eef0ef;
}
.center_pic ul {
  margin: 0px;
  list-style-type: none;
  padding: 0px;
}
.center_pic li {
  position: relative;
  margin: 10px 0 10px 29px;
  width: 262px;
  height: 410px;
  float: left;
  border: 0px dashed #d8d1d1;
}
.center_pic li.selected {
  box-shadow: 0 0 0 2px #00c09e;
  animation: selected 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
  -o-animation: selected 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
  -ms-animation: selected 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
  -moz-animation: selected 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
  -webkit-animation: selected 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}
.imageupload2 {
  width: 210px;
}
.showbox-pic {
  height: 180px;
  display: flex;
  vertical-align: middle;
  align-items: center;
}
.img2 {
  margin: 3px auto;
  max-width: 220px;
  max-height: 180px;
}
.showbox-tit {
  height: 60px;
  span {
    font-size: 18px;
    font-weight: bold;
  }
}
.shopbox-m {
  border-top: 1px dashed #d8d1d1;
  font-size: 18px;
  color: #777;
  padding-top: 10px;
  b {
    color: #000;
    font-weight: 300;
  }
  span {
    color: #e91625;
  }
}
/* 1.all-container-style-start */
</style>
<style>
.center_pic .el-button {
  background: #4ea5db;
  border: 1px solid #4ea5db;
}
.center_pic .el-button:hover {
  background: #4ea5db;
  border: 1px solid #4ea5db;
}
.el-icon-shopping-cart-full {
  font-size: 16px;
}
.shopclass {
  margin-left: 265px;
}
</style>
